import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { SendPackageStateEnumProvider } from "src/Warehouse/SendCartable/sendCartableForm/sendCartableForm-viewModel";
import { ServerSideDataLoader, PaginationInfo, Enum, IEnumTranslator } from "uicomponents";
import { ReceiveCartableDetailViewModel } from "../receiveCartableDetail/receiveCartableDetail-viewModel";
import { ReceiveFormViewModel } from "../receiveForm/receiveForm-viewModel";
import  { ReceiveCartableListView } from "./receiveCartableList-view"

export class ReceiveCartableListViewModel extends WindowViewModel{
    public getTitle(): string {
        return "کارتابل دریافت کالا";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.sendPackages = ObservableArray.create<SendPackage>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.GetAllSendPackages(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new ReceiveCartableListView();
    }
    public getTypeId(): string {
        return "VM-234880A6-DBE6-4EE7-9306-C44A61EEF8B2"
    }
    public set sendPackages(v: ObservableArray<SendPackage>) { this._sendPackages = v; } public get sendPackages(): ObservableArray<SendPackage> { return this._sendPackages;} private _sendPackages: ObservableArray<SendPackage>;
    public set sendPackageStateEnumProvider(v: SendPackageStateEnumProvider) { this._sendPackageStateEnumProvider = v; } public get sendPackageStateEnumProvider(): SendPackageStateEnumProvider { return this._sendPackageStateEnumProvider;} private _sendPackageStateEnumProvider: SendPackageStateEnumProvider;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    async refresh(){
        try {
            this.isLoading = true;
            this.loader.refresh();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async GetAllSendPackages(filteringInformation:any) {
        try {
            if(filteringInformation.OrderInfo.length == 0)
            {
                let sort = {
                    fieldName:'createdTime',
                    order:'DESC',
                    type:'date'
                };
                filteringInformation.OrderInfo = [sort];
            }
            let result = await ServerConnection.callServer('Complex/WarehouseServices/ReceiveCartableList', 
            {
                FilteringInformation:filteringInformation
            });
            this.sendPackages.update(...result.ReceiveCartables.map((q,i)=>{
                let r = new SendPackage(this);
                r.rowNumber = i+1;
                r.sendPackageId = q.SendPackageId;
                r.creationTime = moment.utc(q.CreatedTime);
                r.comment = q.Comment;
                r.orderNumber = q.OrderNumber;
                r.sendPackageState = q.SendPackageState;
                r.toWarehouseId = q.ToWarehouseId;
                r.toWarehouseName = q.ToWarehouseName;
                r.fromWarehouseId = q.FromWarehouseId;
                r.fromWarehouseName = q.FromWarehouseName;
                r.amount = q.Amount;
                r.driverName = q.DriverName;
                r.sendNumber = q.SendNumber;
                r.canReceive = r.sendPackageState === 1;
                return r;
            }))
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
        }
    }

}

export class SendPackage extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ReceiveCartableListViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent : ReceiveCartableListViewModel;

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set sendPackageId(v: string) { this._sendPackageId = v; } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId;} private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName;} private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId;} private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set orderNumber(v: string) { this._orderNumber = v; } public get orderNumber(): string { return this._orderNumber;} private _orderNumber: string;
    public set packageNumber(v: number) { this._packageNumber = v; } public get packageNumber(): number { return this._packageNumber;} private _packageNumber: number;
    public set sendPackageState(v: number) { this._sendPackageState = v; } public get sendPackageState(): number { return this._sendPackageState;} private _sendPackageState: number;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set orderAmount(v: number) { this._orderAmount = v; } public get orderAmount(): number { return this._orderAmount;} private _orderAmount: number;
    public set sendNumber(v: string) { this._sendNumber = v; } public get sendNumber(): string { return this._sendNumber;} private _sendNumber: string;
    public set receiptAmount(v: number) { this._receiptAmount = v; } public get receiptAmount(): number { return this._receiptAmount;} private _receiptAmount: number;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set driverName(v: string) { this._driverName = v; } public get driverName(): string { return this._driverName;} private _driverName: string;
    public set canReceive(v: boolean) { this._canReceive = v; } public get canReceive(): boolean { return this._canReceive;} private _canReceive: boolean;
    
    async showDetail() {
        let receiveCartableDetail = new ReceiveCartableDetailViewModel(this._typedParent, this.sendPackageId);
        let result = await this._typedParent.showPopup(receiveCartableDetail);
        this._typedParent.refresh();
    }

    async receive(){
        let receiveForm = new ReceiveFormViewModel(this._typedParent, this.sendPackageId);
        let result = await this._typedParent.showPopup(receiveForm);
        this._typedParent.refresh();
    }
}
